import { ApolloLink } from './ApolloLink';

export const empty = ApolloLink.empty;



// WEBPACK FOOTER //
// ../../../src/link/core/empty.ts